import { useSelector } from 'react-redux';
import { CASE_TYPE_MAP, getDemandText } from '@demandproai/shared';
import { useProductContext } from '../../../contexts/ProductContext';
import { useTemplateContext } from '../context/TemplateContext';
import TemplateFileCell from '../../../components/common/TemplateFileCell';

const DemandTemplateRow = ({ item }) => {
    const { CASE_TYPE_MAP_MT } = useProductContext();
    const { demandNameMap } = useSelector((state) => state.demandMap);
    const { openModal, removeTemplateFile } = useTemplateContext();
    const resolvedCaseTypeMap = CASE_TYPE_MAP_MT ? { ...CASE_TYPE_MAP, ...CASE_TYPE_MAP_MT } : CASE_TYPE_MAP;

    const { demandType, caseType, state } = item || {};
    const templateFile = item?.data?.templateFile;
    const hasFile = !!item?.exists && !!templateFile;

    return (
        <tr className="group">
            <td>{getDemandText({ state, caseType, value: demandType, demandNameMap })}</td>
            <td>{resolvedCaseTypeMap[caseType]?.text}</td>
            <td>{state}</td>
            <td>
                <TemplateFileCell
                    hasFile={hasFile}
                    filename={item?.data?.templateFileName ?? "Demand Template File"}
                    file={templateFile}
                    onUpload={() => openModal(item)}
                    onDelete={() => removeTemplateFile(item)}
                />
            </td>
        </tr>
    );
};

export default DemandTemplateRow;
